/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Egeyos} from './components/Egeyos'
import {Tryos} from './components/Tryos'
import {Survey} from './components/Survey'
import {CannotRegister} from './components/CannotRegister'
import {UploadConfirmation} from './components/UploadConfirmation'
import {UploadId} from './components/UploadId'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {Languages} from '../../../_metronic/partials/layout/header-menus/Languages'
import {useNavigate} from 'react-router-dom'
import {getRegisterDates} from '../auth/core/_requests'
import {useAuth} from '../auth/core/Auth'
import {getAnnouncements} from '../../pages/announcement/list/core/_requests'
import {useLang} from '../../../_metronic/i18n/Metronici18n'
import {OtherExams} from './components/OtherExams'

const ExamLayout = () => {
  const navigate = useNavigate()
  const {currentUser} = useAuth()
  const lang = useLang()

  const [announcements, setAnnouncements] = useState([])

  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  useEffect(() => {
    // getRegisterDates().then((a: any) => {
    //   if (a.data?.data?.length === 0 && currentUser?.canApplyWithoutRestriction !== '1') {
    //     navigate('/auth/registerpassive')
    //   }
    // })
    getRegisterDates().then((a: any) => {
      if (a.data === false && currentUser?.canApplyWithoutRestriction !== '1') {
        navigate('/auth/registerpassive')
      }
    })
    getAnnouncements().then((a: any) => {
      const activeAnnouncements = a.data?.data?.filter((k: any) => k.isActiveInfoPage) || []
      setAnnouncements(activeAnnouncements)
    })
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid position-x-center bgi-no-repeat bgi-size-cover bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl(
          '/media/illustrations/sketchy-1/unipabackground.jpeg'
        )})`,
      }}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid px-10 pb-lg-20'>
        {/* begin::Logo */}
        <a href='#' className='mb-12'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/tinaztepe.png')} className='h-80px' />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-800px mb-7 mb-lg-0 bg-white rounded shadow-sm px-2 p-lg-15 mx-auto'>
          <div
            className='menu menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
            data-kt-menu='true'
          >
            <Languages languageMenuPlacement='bottom' />
          </div>
          <Outlet />
          {announcements.map((a: any) => {
            return lang === 'tr' ? (
              <div className='alert alert-primary mt-5'>{a.text}</div>
            ) : (
              <div className='alert alert-primary mt-5'>{a.textEn}</div>
            )
          })}
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
    </div>
  )
}

const ExamPage = () => (
  <Routes>
    <Route element={<ExamLayout />}>
      {/* <Route path='egeyos' element={<Egeyos />} /> */}
      <Route path='tryos' element={<Tryos />} />
      {/* <Route path='survey' element={<Survey />} /> */}
      {/* <Route path='cannotregister' element={<CannotRegister />} /> */}
      <Route path='uploadid' element={<UploadId />} />
      <Route path='uploadconfirmation' element={<UploadConfirmation />} />
      <Route path='otherexams' element={<OtherExams />} />
    </Route>
  </Routes>
)

export {ExamPage}
